import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';

import { DescriptionListElement } from '@website-builder/widgets/description-list/description-list-element';
import { DescriptionListContentStyle } from '@website-builder/widgets/description-list/model/description-list-content-style';
import { DescriptionListSubtitleStyle } from '@website-builder/widgets/description-list/model/description-list-subtitle-style';
import { DescriptionListTitleStyle } from '@website-builder/widgets/description-list/model/description-list-title-style';
import { DescriptionListStyle } from '@website-builder/widgets/description-list/model/description-list-style';
import { BaseMultipleWidget } from '@website-builder/widgets/base/base-multiple-widget';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class DescriptionListWidget extends BaseMultipleWidget<DescriptionListElement, DescriptionListStyle> {
  id: string;
  readonly type = BuilderElementType.DescriptionList;
  style = new DescriptionListStyle();
  titleStyle = new DescriptionListTitleStyle();
  subtitleStyle = new DescriptionListSubtitleStyle();
  contentStyle = new DescriptionListContentStyle();

  elements = [
    new DescriptionListElement(),
    new DescriptionListElement(),
    new DescriptionListElement(),
    new DescriptionListElement(),
    new DescriptionListElement(),
  ];

  static normalizeInPlace(widget: DescriptionListWidget): DescriptionListWidget {
    const pureWidget = new DescriptionListWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.id = widget.id ?? pureWidget.id;
    widget.elements = (widget.elements ?? pureWidget.elements).map(element =>
      DescriptionListElement.normalizeInPlace(element),
    );

    widget.style = DescriptionListStyle.normalize(widget.style);
    widget.titleStyle = DescriptionListTitleStyle.normalize(widget.titleStyle);
    widget.subtitleStyle = DescriptionListSubtitleStyle.normalize(widget.subtitleStyle);
    widget.contentStyle = DescriptionListContentStyle.normalize(widget.contentStyle);

    return widget;
  }
}
